import {
	DOWNLOAD_FILES_OPTIONS,
	DOWNLOAD_FILES_OPTIONS_VALUES
} from 'modules/core/constants'
import { ReleaseType, UserType } from '../../../generated/types'

type DownloadOptionVisibilityArgs = {
	option: string
	user: UserType
	release: ReleaseType
	selectedReleaseToCompareId?: string
}

export const shouldSkipDownloadOption = ({
	option,
	user,
	release,
	selectedReleaseToCompareId
}: DownloadOptionVisibilityArgs): boolean => {
	const catalogType = release.catalogType
	const attachmentsAvailable =
		release.isAttachmentsDirExist && !!catalogType?.hasAttachmentFiles
	const pcxFilesAvailable = release.isPcxFilesExist !== false

	if (
		option === DOWNLOAD_FILES_OPTIONS.INCLUDE_PCX_FILES &&
		!user.isVswUser &&
		!user.isKasseUser
	) {
		return true
	}

	if (
		option === DOWNLOAD_FILES_OPTIONS.INCLUDE_PCX_FILES &&
		(!attachmentsAvailable || !pcxFilesAvailable)
	) {
		return true
	}

	if (
		!release.isAttachmentsDirExist &&
		option === DOWNLOAD_FILES_OPTIONS.INCLUDE_ATTACHMENTS
	) {
		return true
	}

	if (
		option === DOWNLOAD_FILES_OPTIONS.INCLUDE_REVISION_HISTORY_FILE &&
		!selectedReleaseToCompareId
	) {
		return true
	}

	if (
		!user.isSuperuser &&
		user.hasSelectedContracts &&
		(option === DOWNLOAD_FILES_OPTIONS.INCLUDE_BASE_FILE ||
			option === DOWNLOAD_FILES_OPTIONS.INCLUDE_HELP_FILES)
	) {
		return true
	}

	if (catalogType) {
		if (
			!catalogType.hasPdfRequirementDocument &&
			option === DOWNLOAD_FILES_OPTIONS.INCLUDE_AKA_PDF
		) {
			return true
		}
		if (
			!catalogType.hasPdfChangeLog &&
			option === DOWNLOAD_FILES_OPTIONS.INCLUDE_REVISION_HISTORY_FILE
		) {
			return true
		}
		if (
			!catalogType.hasXmlBaseFile &&
			option === DOWNLOAD_FILES_OPTIONS.INCLUDE_BASE_FILE
		) {
			return true
		}
		if (
			!catalogType.hasSvdFiles &&
			option === DOWNLOAD_FILES_OPTIONS.INCLUDE_SVD_XML_FILES
		) {
			return true
		}
		if (
			!catalogType.hasPdfVerificationDocuments &&
			option === DOWNLOAD_FILES_OPTIONS.INCLUDE_SVD_PDF_FILES
		) {
			return true
		}
		if (
			!catalogType.hasAttachmentFiles &&
			option === DOWNLOAD_FILES_OPTIONS.INCLUDE_ATTACHMENTS
		) {
			return true
		}
		if (
			!catalogType.hasMiscHelperFiles &&
			option === DOWNLOAD_FILES_OPTIONS.INCLUDE_HELP_FILES
		) {
			return true
		}
		if (
			!catalogType.hasCsvServiceOverviews &&
			option === DOWNLOAD_FILES_OPTIONS.INCLUDE_INSPECTION_DOCUMENT_CSV_FILES
		) {
			return true
		}
	}

	if (!user.isSuperuser) {
		const isKasseUserOption =
			user.isKasseUser &&
			(option === DOWNLOAD_FILES_OPTIONS.INCLUDE_BASE_FILE ||
				option === DOWNLOAD_FILES_OPTIONS.INCLUDE_HELP_FILES ||
				option === DOWNLOAD_FILES_OPTIONS.INCLUDE_SVD_XML_FILES)

		const isVswUserOption =
			user.isVswUser &&
			option === DOWNLOAD_FILES_OPTIONS.INCLUDE_INSPECTION_DOCUMENT_CSV_FILES

		if (isKasseUserOption || isVswUserOption) {
			return true
		}
	}

	return false
}

type AvailableDownloadOptionsArgs = {
	user: UserType
	release: ReleaseType
	selectedReleaseToCompareId?: string
}

export const getAvailableDownloadOptions = ({
	user,
	release,
	selectedReleaseToCompareId
}: AvailableDownloadOptionsArgs): string[] => {
	return DOWNLOAD_FILES_OPTIONS_VALUES.filter(
		option =>
			!shouldSkipDownloadOption({
				option,
				user,
				release,
				selectedReleaseToCompareId
			})
	)
}
